module.exports = __webpack_public_path__ + "static/media/onsoc_medium@2x.dc15aed9.jpg";